import { Button, Tooltip } from 'antd';
import React, { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { pushHistory } from '@/infrastructure/history';
import { getProductId, getPid } from '@/infrastructure/product-info';
import { useTranslation } from 'react-i18next';

export const TapdTips: FC = (props) => {
  const { t } = useTranslation();
  const history = useHistory();
  const gotoTapd = () => pushHistory(history, `/v2setting/product-config?tab=tapd&productId=${getProductId()}&pid=${getPid()}`);

  return <Tooltip
    color='#fff'
    overlayInnerStyle={{ width: '300px' }}
    title={
      <div style={{ color: 'black', display: 'flex', alignItems: 'center' }}>
        {t("请先完善TAPD配置，然后再提单")}
        <Button
          type='link'
          onClick={gotoTapd}
        >
          {t("去完善")}
        </Button>
      </div>}
  >
    {props.children}
  </Tooltip>;
};
